import PageHero from '@/components/PageHero';
import PlatformsSection from '@/components/PlatformsSection';
import TripleSection from '@/components/TripleSection';
import CTABanner from '@/components/CTABanner';

export default function Platforms() {
  return (
    <>
      <PageHero
        eyebrow="Wherever you work"
        title="Three surfaces. One file."
        sub="Your matter is the same wherever you open it — web for desk work, macOS for deep drafting, iOS for hearings and on-the-go review. One contract, one design system, one source of truth."
      />

      <PlatformsSection />

      <TripleSection
        id="surfaces"
        label="Built for the moment"
        title="The right surface for the work in front of you."
        cards={[
          { num: '/ WEB', title: 'avowal.ai', body: 'The desk surface. Intake, matter review, document approval, and the full client portal — in any browser, nothing to install. In private beta now.' },
          { num: '/ MACOS', title: 'AVOWAL Desktop', body: 'The drafting surface. Native macOS app for attorneys doing deep work: side-by-side drafting, citation review, and exhibit assembly. Mac App Store — in development.' },
          { num: '/ IOS', title: 'AVOWAL Mobile', body: 'The courtroom surface. Native iPhone app for hearings and on-the-go review: matter status, filing chains, and chain-verified evidence in your pocket. App Store — in development.' },
        ]}
      />

      <CTABanner />
    </>
  );
}
